import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code"} maskId="square-filled-radius-0-stroke-1-IconCode"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM10.1464 8.64645L10.8536 9.35355L8.20711 12L10.8536 14.6464L10.1464 15.3536L6.79289 12L10.1464 8.64645ZM13.1464 9.35355L15.7929 12L13.1464 14.6464L13.8536 15.3536L17.2071 12L13.8536 8.64645L13.1464 9.35355Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCode;
